"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheAlttaiStandard() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223707" id="the-alttai-standard" className="bg-background text-foreground py-24 lg:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-0 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-lg blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="relative group order-2 lg:order-1">
            <div className="absolute -inset-1 bg-gradient-to-tr from-secondary/40 to-transparent rounded-md blur-xl opacity-50 group-hover:opacity-70 transition-opacity duration-700" />
            <div className="relative aspect-square lg:aspect-[4/5] rounded-md overflow-hidden border border-secondary/30 shadow-xl bg-muted">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686328/img/marine_gear_precision_seal.png" alt="High-precision marine gear with a silver Quality Seal overlay" className="w-full h-full object-cover opacity-100 transition-all duration-700 scale-105 group-hover:scale-100" />
              {}
              <div className="absolute inset-0 border border-secondary/20 rounded-md pointer-events-none mix-blend-overlay" />
              <div className="absolute top-4 left-4 w-2 h-2 bg-secondary rounded-lg animate-pulse" />
            </div>
          </div>

          {}
          <div className="order-1 lg:order-2 bg-card/60 backdrop-blur-md border border-border p-8 sm:p-10 lg:p-12 rounded-md shadow-md relative overflow-hidden">
            {}
            <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686328/img/marine_wave_pattern.png')] bg-repeat opacity-10 pointer-events-none mix-blend-multiply" />

            <div className="relative z-10">
              <Badge variant="outline" className="mb-8 font-mono text-xs tracking-widest border-secondary/50 text-primary bg-secondary/10 px-3 py-1 uppercase">
                Japanese Engineering
              </Badge>

              <h2 className="font-default text-3xl sm:text-4xl lg:text-5xl font-bold mb-8 text-primary tracking-tight leading-tight">
                The ALTTAI <br className="hidden sm:block" />
                <span className="text-secondary font-light">
                  Standard
                </span>
              </h2>

              <div className="columns-1 sm:columns-2 gap-x-8 text-sm text-foreground leading-relaxed font-sans space-y-6 sm:space-y-0">
                <p>
                  At ALTTAI MARINE, we uphold the rigorous standards of Japanese 
                  OEM engineering. Our commitment to precision ensures that every 
                  marine spare part—from propellers to intricate gears—meets the 
                  highest benchmarks of durability and performance in the 
                  harshest oceanic environments.
                </p>
                <p>
                  By integrating advanced manufacturing techniques with marine-grade 
                  materials, we provide components that are fully compatible with 
                  Yamaha outboards and other leading brands. We empower marine 
                  professionals with the reliability required for trusted 
                  performance on the open water.
                </p>
              </div>

              <div className="mt-10 pt-8 border-t border-border flex items-center justify-between">
                <div className="flex flex-col">
                  <span className="font-mono text-xs text-muted-foreground uppercase tracking-wider mb-1">
                    Quality Assurance
                  </span>
                  <span className="font-default text-sm text-primary font-medium">
                    View our technical catalog
                  </span>
                </div>
                <Link to="/ProductsPage">
                  <Button variant="default" size="icon" className="rounded-md w-12 h-12 bg-primary text-primary-foreground shadow-md hover:bg-primary/90 transition-all duration-300">
                    <ArrowRight className="size-5" />
                    <span className="sr-only">Explore Products</span>
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}